import React from 'react';

const CloseIcon: React.FC = () => {
    return (
        <path
              d="M23.667,6.88,21.787,5l-7.453,7.453L6.88,5,5,6.88l7.453,7.453L5,21.787l1.88,1.88,7.453-7.453,7.453,7.453,1.88-1.88-7.453-7.453Z"
              transform="translate(1.667 1.667)"/>
    )
}

export default CloseIcon;
